module.exports = __webpack_public_path__ + "img/download-file.7d247095.svg";